import styled from 'styled-components'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import { OptionButton as SharedOptionButton } from '~/pages/anatomyV2/libs/optionButtonStyles'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const MultiSelectQuestionTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
  `,

  ProgressWrapper: styled.div`
    padding: 16px 16px 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0 16px;
  `,

  Options: styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
  `,

  OptionButton: styled(SharedOptionButton)`
    display: flex;
    align-items: center;
    gap: 12px;

    &:not(:last-of-type) {
      margin-bottom: 0;
    }
  `,

  OptionEmoji: styled.span`
    font-size: 20px;
    line-height: 1;
  `,

  OptionLabel: styled.span`
    flex: 1;
    font-family: 'Mulish', sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.2;
    text-align: left;
    color: ${COLORS.BLACK};
  `,

  Checkbox: styled.span<{ $isSelected: boolean }>`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1.5px solid
      ${({ $isSelected }) =>
        $isSelected ? ANATOMY_V2_ACCENT_COLOR : COLORS.GRAY_400};
    background-color: ${({ $isSelected }) =>
      $isSelected ? ANATOMY_V2_ACCENT_COLOR : 'transparent'};
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      display: ${({ $isSelected }) => ($isSelected ? 'block' : 'none')};
      width: 5px;
      height: 9px;
      border: 2px solid ${COLORS.WHITE};
      border-top: none;
      border-left: none;
      transform: rotate(45deg) translate(-1px, -1px);
    }
  `,

  ButtonWrapper: styled.div`
    position: relative;
    width: 100%;
    padding: 16px;

    &::before {
      content: '';
      position: absolute;
      top: -24px;
      left: 0;
      right: 0;
      height: 24px;
      background: linear-gradient(
        180deg,
        rgba(239, 245, 247, 0) 0%,
        ${COLORS.GRAY_100} 100%
      );
      pointer-events: none;
    }
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
}
